class CollectionSortMenu {
  constructor() {
    this.onSortChange = this.onSortChange.bind(this);
    this.init();
  }

  init() {
    document.querySelectorAll('.collection-sort-menu').forEach((menu) => {
      menu.querySelectorAll('input[name="sort_by"]').forEach((input) => {
        input.removeEventListener('change', this.onSortChange);
        input.addEventListener('change', this.onSortChange);
      });

      const summary = menu.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', () => {
          document.querySelectorAll('.facets__filter-menu[open]').forEach((filterMenu) => {
            filterMenu.removeAttribute('open');
          });
        });
      }
    });

    document.querySelectorAll('.facets__filter-menu summary').forEach((summary) => {
      summary.addEventListener('click', () => {
        document.querySelectorAll('.collection-sort-menu[open]').forEach((sortMenu) => {
          sortMenu.removeAttribute('open');
        });
      });
    });
  }

  onSortChange(event) {
    event.target.dispatchEvent(new Event('input', { bubbles: true }));

    const menu = event.target.closest('.collection-sort-menu');
    if (menu) menu.removeAttribute('open');

    document.querySelectorAll('.collection-sort-menu').forEach((otherMenu) => {
      if (otherMenu !== menu) otherMenu.removeAttribute('open');
    });

    document.querySelectorAll('.facets__filter-menu[open]').forEach((filterMenu) => {
      filterMenu.removeAttribute('open');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.collectionSortMenu = new CollectionSortMenu();
});

document.addEventListener('shopify:section:load', () => {
  window.collectionSortMenu?.init();
});

document.addEventListener('facets:rendered', () => {
  window.collectionSortMenu?.init();
});
